import { Link, useParams } from 'react-router-dom';
import { Menu, X, FileText, Shield, Info, HelpCircle, BookOpen, Mail } from 'lucide-react';
import { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const NavigationMenu = () => {
  const { language } = useLanguage();
  const { lang } = useParams<{ lang: string }>();
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    {
      path: `/${lang}`,
      label: language === 'zh' ? '首页' : 'Home',
      icon: null
    },
    {
      path: `/${lang}/blog`,
      label: language === 'zh' ? '博客' : 'Blog',
      icon: <BookOpen className="w-4 h-4" />
    },
    {
      path: `/${lang}/about`,
      label: language === 'zh' ? '关于' : 'About',
      icon: <Info className="w-4 h-4" />
    },
    {
      path: `/${lang}/help`,
      label: language === 'zh' ? '帮助' : 'Help',
      icon: <HelpCircle className="w-4 h-4" />
    },
    {
      path: `/${lang}/contact`,
      label: language === 'zh' ? '联系' : 'Contact',
      icon: <Mail className="w-4 h-4" />
    }
  ];

  return (
    <div className="relative">
      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="p-2 text-white hover:bg-white/10 rounded-lg transition-colors md:hidden"
        aria-label="Toggle menu"
      >
        {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>

      {/* Desktop Menu */}
      <nav className="hidden md:flex items-center space-x-1">
        {menuItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className="flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
          >
            {item.icon}
            {item.label}
          </Link>
        ))}
      </nav>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="absolute right-0 top-12 z-50 md:hidden">
          <div className="bg-slate-900/95 backdrop-blur-lg rounded-xl border border-white/10 shadow-xl min-w-48">
            <nav className="p-2">
              {menuItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className="flex items-center gap-3 px-4 py-3 text-gray-300 hover:text-white hover:bg-white/10 rounded-lg transition-colors text-sm"
                >
                  {item.icon}
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}

      {/* Mobile Menu Backdrop */}
      {isOpen && (
        <div
          className="fixed inset-0 z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default NavigationMenu;